import { createContext, useContext, useReducer } from 'react';

const ParcelScanContext = createContext(null);

export const useParcelScanContext = () => {
  const ctx = useContext(ParcelScanContext);
  if (!ctx) throw new Error('useParcelScanContext doit être utilisé dans <ParcelScanProvider>');
  return ctx;
};

const initialState = {
  fetchAlert: false,
  alertMessage: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_PARCEL_SCAN_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function ParcelScanProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { ...state, dispatch };
  return <ParcelScanContext.Provider value={value}>{children}</ParcelScanContext.Provider>;
}
